/**
 * PostHog 分析工具
 * 封装 PostHog 事件追踪功能
 */

import posthog from 'posthog-js';

/**
 * 追踪自定义事件
 * @param eventName 事件名称
 * @param properties 事件属性
 */
export const trackEvent = (
  eventName: string,
  properties?: Record<string, string | number | boolean>
) => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.capture(eventName, properties);
    
    // 开发环境打印日志
    if (import.meta.env.DEV) {
      console.log('[PostHog Event]', eventName, properties);
    }
  } catch (error) {
    console.error('[PostHog] Failed to track event:', error);
  }
};

/**
 * 识别用户
 * @param userId 用户ID
 * @param properties 用户属性
 */
export const identifyUser = (
  userId: string,
  properties?: Record<string, string | number | boolean>
) => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.identify(userId, properties);
    
    if (import.meta.env.DEV) {
      console.log('[PostHog Identify]', userId, properties);
    }
  } catch (error) {
    console.error('[PostHog] Failed to identify user:', error);
  }
};

/**
 * 设置用户属性
 * @param properties 用户属性
 */
export const setUserProperties = (
  properties: Record<string, string | number | boolean>
) => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.setPersonProperties(properties);
  } catch (error) {
    console.error('[PostHog] Failed to set user properties:', error);
  }
};

/**
 * 重置用户会话（登出时调用）
 */
export const resetUser = () => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.reset();
  } catch (error) {
    console.error('[PostHog] Failed to reset user:', error);
  }
};

/**
 * 追踪页面浏览
 * @param pageName 页面名称
 */
export const trackPageView = (pageName?: string) => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.capture('$pageview', {
      page_name: pageName,
    });
  } catch (error) {
    console.error('[PostHog] Failed to track page view:', error);
  }
};

// 预定义的事件类型
export const Events = {
  // 认证相关
  STUDENT_LOGIN: 'student_login',
  TEACHER_LOGIN: 'teacher_login',
  LOGOUT: 'logout',
  
  // 作业相关
  ASSIGNMENT_SUBMIT: 'assignment_submit',
  ASSIGNMENT_VIEW: 'assignment_view',
  ASSIGNMENT_REVIEW: 'assignment_review',
  
  // 照片相关
  PHOTO_UPLOAD: 'photo_upload',
  PHOTO_VIEW: 'photo_view',
  PHOTO_DELETE: 'photo_delete',
  
  // 课程相关
  COURSE_VIEW: 'course_view',
  PROGRESS_CHECK: 'progress_check',
  
  // 用户交互
  THEME_TOGGLE: 'theme_toggle',
  TAB_SWITCH: 'tab_switch',
} as const;
